import React, { ChangeEvent, useState } from 'react';

type Callback = ChangeEvent<HTMLInputElement> | string;

const useMemberForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const setValue = (
    e: Callback,
    fn: React.Dispatch<React.SetStateAction<string>>,
  ) => {
    if (typeof e === 'object') {
      fn((e as ChangeEvent<HTMLInputElement>).target.value);
    } else {
      fn(e as string);
    }
  };

  const onNameChange = (e: Callback) => {
    setValue(e, setName);
  };

  const onEmailChange = (e: Callback) => {
    setValue(e, setEmail);
  };

  const onFirstNameChange = (e: Callback) => {
    setValue(e, setFirstName);
  };

  const onLastNameChange = (e: Callback) => {
    setValue(e, setLastName);
  };

  const onPassChange = (e: Callback) => {
    setValue(e, setPassword);
  };

  const onConfirmPassChange = (e: Callback) => {
    setValue(e, setConfirmPassword);
  };

  return {
    name,
    email,
    firstName,
    lastName,
    password,
    confirmPassword,

    setName: onNameChange,
    setEmail: onEmailChange,
    setFirstName: onFirstNameChange,
    setLastName: onLastNameChange,
    setPassword: onPassChange,
    setConfirmPassword: onConfirmPassChange,
  };
};

export default useMemberForm;
